/**
 * @description List of actions supported by blocks.
 */
export enum ContextActionType {
  SAVE_AS_MODULE = 'saveAsModule',
  IMPROVE_WITH_AI = 'improveWithAI',
  MOVE = 'move',
  COPY = 'copy',
  REMOVE = 'remove',
  CLEAR_CONTAINER = 'clearContainer',
  EXTERNAL_DISPLAY_CONDITION = 'externalDisplayCondition',
}
